<template>
  <div class="attendancce-punch">
    <div class="pb16">库存管理</div>
    <div class="mains-content">
      <div class="item_title">库存操作</div>
      <div class="flex-row">
        <div v-for="(item, index) in list" :key="index" @click="onClick(item)" class="attendancce-list"
          v-perm="{ key: 'inventory', value: item.auth }">
          <span class="box-img"><img :src="item.icon" alt=""></span> <span class="ml10 fs16 fb">{{ item.name }}</span>
        </div>
      </div>
      <div class="item_title mt30">库内管理</div>
      <div class="flex-row">
        <div v-for="(item, index) in statisticalList" :key="index" @click="onClick(item)" class="attendancce-list"
          v-perm="{ key: 'inventory', value: item.auth }">
          <span class="box-img"><img :src="item.icon" alt=""></span> <span class="ml10 fs16 fb">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <addPurchaseStorage-set ref="addPurchaseStorageForm" @change="addPurchaseStorage"></addPurchaseStorage-set>
    <addInventoryStorage-set ref="addInventoryStorageForm" @change="addInventoryStorage"></addInventoryStorage-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import addPurchaseStorageSet from "./addPurchaseStorage.vue";
import addInventoryStorageSet from "./addInventoryStorage.vue";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [
        { name: '新增采购', code: 'purchaseStorage', url: '/dataList/purchaseStorage', icon: require("../../../assets/images/inventory/purchaseStorage.png"), auth: 'inventory:purchase' },
        { name: '其他入库', code: 'inventoryStorage', url: '/dataList/inventoryStorage', icon: require("../../../assets/images/inventory/inventoryStorage.png"), auth: 'inventory:storage' },
        { name: '出库申请', code: 'inventoryWastage', url: '/dataList/inventory/inventoryWastage', icon: require("../../../assets/images/inventory/inventoryWastage.png"), auth: 'inventory:wastage' },
        { name: '库存盘点', code: 'inventoryCheck', url: '/dataList/inventory/inventoryCheck', icon: require("../../../assets/images/inventory/inventoryCheck.png"), auth: 'inventory:check' }
      ],
      statisticalList: [
        { name: '出入库记录', code: 'inventoryBill', url: '/dataList/inventory/inventoryBill', icon: require("../../../assets/images/inventory/inventoryBill.png"), auth: 'inventory:record' },
        { name: '预警推送设置', code: 'warningPushSetting', url: '/dataList/warningPushSetting', icon: require("../../../assets/images/inventory/warningPushSetting.png"), auth: 'inventory:setting' },
        { name: '库存查询', code: 'inventoryInquire', url: '/dataList/inventoryInquire', icon: require("../../../assets/images/inventory/warningPushSetting.png"), auth: 'inventory:query' },
      ],
      height: this.$store.getters.MainHeight,
      columns: config.columns,
      query: {},
    };
  },
  components: { addPurchaseStorageSet, addInventoryStorageSet },
  created() { },
  mounted() { },
  methods: {
    onClick(item) {
      if (item.code == 'purchaseStorage') {
        this.$refs["addPurchaseStorageForm"].$emit("set", { orderId: "", sourceFrom: "" });
      } else if (item.code == 'inventoryStorage') {
        this.$refs["addInventoryStorageForm"].$emit("set", { orderId: "", sourceFrom: "" });
      } else {
        this.$router.push(item.url)
      }
    },
    addPurchaseStorage() {

    },
    addInventoryStorage() {

    },
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";

.attendancce-punch {
  position: relative;
  padding: 16px 16px 0;

  .attendancce-list {
    width: 200px;
    height: 100px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 10px;
  }

  .box-img {
    display: inline-block;
    width: 48px;
    height: 48px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.mains-content {
  height: calc(100vh - 160px);
  background-color: #fff;
  border-radius: 10px;
  padding: 16px;
}

.item_title {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin-bottom: 24px;
}
</style>